import Api from './Api';

const END_POINT = 'importations';

export default {
    get_all(filters = null) {
        let request = {
            params: filters
        }
        return Api.get(`${END_POINT}`, request);
    },
    store(brand) {
        return Api.post(`${END_POINT}`, brand);
    }
}